<template>
  <el-card class="h-full relative">
    <div class="w-full h-full">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="考试名称"
          maxlength="50"
          v-model="searchData.keywords"
          clearable
        ></el-input>
        <department-select
          class="mr-10px !w-50 mb-10px"
          v-model="searchData.departmentId"
        ></department-select>
        <el-select
          v-model="searchData.examCategory"
          size="small"
          class="mr-10px !w-50 mb-10px mb-10px"
          placeholder="请选择考试类型"
          clearable
        >
          <el-option
            v-for="item in pagerTypeList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="searchData.examStartTime"
          type="date"
          size="small"
          class="mr-10px !w-50"
          :placeholder="`${$t('开始日期')}`"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-date-picker
          v-model="searchData.examEndTime"
          type="date"
          size="small"
          class="mr-10px !w-50"
          :placeholder="`${$t('结束日期')}`"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button size="small" type="primary" @click="sizeChange()">搜索</el-button>
        <el-button
          size="small"
          @click="batchExport()"
          :disabled="!$hasAccess('export')"
          :loading="batchExportLoading"
          >批量导出</el-button
        >
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        ref="tableRef"
        stripe
        v-loading="equipTableLoading"
        row-key="unique"
        :tree-props="{
          children: 'taskExamAnswerRecordManageSessionDtos',
          hasChildren: 'hasChildren',
        }"
        @expand-change="expandHandle"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" align="center"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="考试/试卷名称"
          prop="examName"
          min-width="280"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="考试编码"
          width="160"
          prop="examCode"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="考试类型"
          prop="examCategoryStr"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="考试时间" prop="examStartTime" width="280" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row | showText('time') }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="考试时长（min）"
          prop="examDuration"
          width="135"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column
          label="参加总人数"
          prop="examPeopleTotal"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="已通过人数"
          width="100"
          prop="examPassPeopleTotal"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column width="70" label="通过率" prop="passRate" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" width="210" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="viewInfo(scope.row)" :disabled="!$hasAccess('read')"
              >查看</el-button
            >
            <el-button
              size="mini"
              :loading="scope.row.exportLoading"
              @click="exportData(scope.row)"
              :disabled="!$hasAccess('export')"
              >导出</el-button
            >
            <el-button
              size="mini"
              @click="goAnew(scope.row)"
              :disabled="!$hasAccess('anew') || !scope.row.isCanMakeUpExam"
              >补考</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="sizeChange"
        @current-change="searchList"
        :current-page.sync="page.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :page-size.sync="page.pageSize"
        :total="page.pageTotal"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <AnewDia
      :visible.sync="anewVis"
      v-if="anewVis"
      :operateData="operateData"
      @handleOk="sizeChange"
    />
  </el-card>
</template>

<script>
import { TaskExamAnswerRecordApi } from '@wiz-api/exam-management'
import dayjs from 'dayjs'
import { uniq } from 'lodash'
import { download } from '@/assets/js/CommonDownload'
import utils from '@/components/safety/enumField/utils'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import AnewDia from '../../components/examManage/AnewAction'

const taskExamAnswerRecordApi = new TaskExamAnswerRecordApi()

export default {
  name: 'examine-paper',
  components: { AnewDia, DepartmentSelect },
  data() {
    return {
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      typeList: ['是', '否'],
      searchData: {
        examStartTime: null,
        keywords: '',
        examEndTime: '',
        examCategory: '',
        departmentId: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      operateType: '',
      operateData: {},
      currentOpen: {},
      anewVis: false,
      showAdminTable: true,
      pagerTypeList: [],
      selection: [],
      batchExportLoading: false,
    }
  },
  filters: {
    showText: (val, type) => {
      let result = ''
      if (type === 'time') {
        result = `${dayjs(val.examStartTime).format('YYYY-MM-DD HH:mm')} - ${dayjs(
          val.examEndTime
        ).format('YYYY-MM-DD HH:mm')}`
      }
      return result
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },
  methods: {
    handleSelectionChange(selection) {
      this.selection = selection
    },
    async batchExport() {
      if (!this.selection.length) {
        this.$message.warning('请选择要导出的数据')
        return
      }
      let ids = []
      this.selection.forEach((item) => {
        if (item.taskExamAnswerRecordManageSessionDtos) {
          item.taskExamAnswerRecordManageSessionDtos.forEach((session) => {
            ids.push(session.sessionId)
          })
        } else {
          ids.push(item.sessionId)
        }
      })
      ids = uniq(ids)
      this.batchExportLoading = true
      const [err, res] = await taskExamAnswerRecordApi.eaxmSessionRecordExportToExcelFile({
        body: {
          ids,
        },
      })
      if (!err) {
        download(
          `考试记录汇总${dayjs().format('YYYYMMDDHHmmss')}`,
          res,
          ids.length > 1
            ? 'application/zip'
            : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        )
      }
      this.batchExportLoading = false
    },
    expandHandle(row, isOpen) {
      if (isOpen) {
        if (Object.keys(this.currentOpen).length) {
          this.$refs.tableRef.toggleRowExpansion(this.currentOpen, false)
        }
        this.currentOpen = row
      } else {
        this.currentOpen = {}
      }
    },
    // 导出
    async exportData(data) {
      data.exportLoading = true
      let ids = []
      if (data.taskExamAnswerRecordManageSessionDtos) {
        data.taskExamAnswerRecordManageSessionDtos.forEach((session) => {
          ids.push(session.sessionId)
        })
      } else {
        ids.push(data.sessionId)
      }
      ids = uniq(ids)
      const [err, res] = await taskExamAnswerRecordApi.eaxmSessionRecordExportToExcelFile({
        body: {
          ids,
        },
      })
      data.exportLoading = false
      if (!err) {
        download(
          `${data.examName}考试记录`,
          res,
          ids.length > 1
            ? 'application/zip'
            : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        )
      }
    },
    // 文件流下载
    downLoadExcel(fileName = '下载文件', data, type) {
      const fileType = {
        zip: 'application/zip',
        excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }
      const blob = new Blob([data], {
        type: fileType[type],
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 重考
    goAnew(data) {
      this.operateData = data
      this.anewVis = true
    },
    // 查看
    viewInfo(data) {
      const url = Wiz?.globalSettings?.globalConfig?.routerBase
        ? `/${Wiz.globalSettings.globalConfig.routerBase}/educational-training-management-sm/exam-manage/exam-record-info`
        : '/educational-training-management-sm/exam-manage/exam-record-info'
      const query = {
        id: data.planId,
      }
      if (data.sessionId) {
        query.sessionId = data.sessionId
      }
      if (data.makeUpExamRootNodeId) {
        query.mainSessionId = data.makeUpExamRootNodeId
      }
      this.$router.push({
        path: url,
        query,
      })
    },
    // 操作
    actionHandle(planRow, type) {
      this.operateType = type
      this.operateData = planRow
      this.showAddDialog = true
    },
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.sizeChange()
    },
    /**
     * @description 分页数改变
     */
    sizeChange() {
      this.page.pageNo = 1
      this.searchList()
    },
    // 列表
    async searchList() {
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        ...searchData,
      }
      // if (data.examStartTime) {
      //   data.examStartTime = dayjs(data.examStartTime).format('YYYY-MM-DD HH:mm:ss')
      // }
      // if (data.examEndTime) {
      //   data.examEndTime = dayjs(data.examEndTime).format('YYYY-MM-DD 23:59:59')
      // }
      this.equipTableLoading = true
      const [err, res] = await taskExamAnswerRecordApi[
        this.showAdminTable ? 'managePagedListQuery' : 'examineePageList'
      ](data)
      this.equipTableLoading = false
      if (!err) {
        this.showAdminTable &&
          res.items.forEach((item, index) => {
            item.unique = item.planId + (this.page.pageNo - 1) * this.page.pageSize + index
            item.taskExamAnswerRecordManageSessionDtos.forEach((item2, index2) => {
              item2.unique =
                item.planId + (this.page.pageNo - 1) * this.page.pageSize + index2 + 1000
            })
          })
        this.equipDataList = res.items.map((item) => {
          item.taskExamAnswerRecordManageSessionDtos = item.taskExamAnswerRecordManageSessionDtos.map(
            (taskExamAnswerRecord) => {
              const examStartTime = new Date(taskExamAnswerRecord.examStartTime)
              const examEndTime = new Date(taskExamAnswerRecord.examEndTime)
              // 计算考试时长
              const minute = Math.floor(
                Math.abs(new Date(examEndTime) - new Date(examStartTime)) / 60000
              )
              taskExamAnswerRecord.sessionDuration = taskExamAnswerRecord.examDuration
              taskExamAnswerRecord.examDuration = minute
              return taskExamAnswerRecord
            }
          )
          item.exportLoading = false
          return item
        })
        this.page.pageTotal = res.totalCount
      }
    },
  },
  mounted() {
    utils.getDataCategory(['ExamManagement.DataCategory.ExamType'], ['pagerTypeList'], this)
    // const role = Wiz.AuthHooks.GetUserInfo().profile.role || ''
    // this.showAdminTable = role.includes('admin')
    this.searchList()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
